import styles from './Modal.module.css';

export function ButtonsBar({ className = '', children }) {
  return (
    <div
      className={`${styles.bottomBar} !px-4 !py-3 sm:!px-10 bg-white border-t border-slate-300 justify-between items-end flex ${className}`.trim()}
    >
      {children}
    </div>
  );
}
